import { ComponentProps } from "react";
import { Box, Grid } from "@mui/material";
import BiomassProjectForm from "../biomassProjectForm";

type ActivityScreeningSectionProps = {
  biomassProjectFormProps: ComponentProps<typeof BiomassProjectForm>;
};

const ActivityScreeningSection = ({
  biomassProjectFormProps,
}: ActivityScreeningSectionProps) => (
  <Box sx={{ mt: -4, minHeight: 260 }}>
    <Grid container rowSpacing={3} columnSpacing={2} sx={{ mb: 2 }}>
      <Grid item xs={12}>
        <BiomassProjectForm {...biomassProjectFormProps} />
      </Grid>
    </Grid>
  </Box>
);

export default ActivityScreeningSection;
